import { AgencyConstants } from 'features/Agency/agencyHelper';
import WizardStep from 'general/components/quybka/Wizards/WizardStep';
import AppColors from 'general/constants/AppColors';
import Utils from 'general/utils/Utils';
import PropTypes from 'prop-types';
import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

AgencySaleOrderWizardView.propTypes = {
  orderType: PropTypes.string,
  orderItem: PropTypes.object,
  contractItem: PropTypes.object,
  technicalAcceptance: PropTypes.object,
  financialAcceptance: PropTypes.object,
};

function AgencySaleOrderWizardView({
  orderType = AgencyConstants.SaleOrderType.GROUP,
  orderItem,
  contractItem,
  technicalAcceptance,
  financialAcceptance,
}) {
  // MARK: ---- PROPERTIES ----
  const user = useSelector((state) => state.auth.user);
  const isAdmin = user?.role === 'ADMIN' || user?.role === 'OPERATOR';
  const isAgency = user?.role === 'AGENCY';
  const [currentStep, setCurrentStep] = useState(1);
  useEffect(() => {
    let step = 1;
    console.log({ orderType, orderItem, contractItem });
    if (Utils.isValid(orderItem)) {
      if (orderType === AgencyConstants.SaleOrderType.INVESTOR) {
        // don hang ban nhuong quyen
        if (
          [
            AgencyConstants.SaleOrderStatus.ORDERED,
            // AgencyConstants.SaleOrderStatus.SHIPPING,
            // AgencyConstants.SaleOrderStatus.INSTALLING,
            // AgencyConstants.SaleOrderStatus.INSTALLED,
          ].includes(orderItem?.status)
        ) {
          if (!contractItem || contractItem?.status === AgencyConstants.ContractStatus.CREATED) step = 2;
          else if (contractItem?.status === AgencyConstants.ContractStatus.ADMIN_SIGNED) step = 3;
          else if (contractItem?.status === AgencyConstants.ContractStatus.COMPLETED) step = 4;
        }
        else if (orderItem?.status === AgencyConstants.SaleOrderStatus.PAID || orderItem?.status === AgencyConstants.SaleOrderStatus.INSTALLED) step = 5;
        else if (orderItem?.status === AgencyConstants.SaleOrderStatus.COMPLETED) {
          step = 6;
        }
      } else if (orderType === AgencyConstants.SaleOrderType.GROUP) {
        // don hang ban goi dau tu HTKD
        if (orderItem?.status === AgencyConstants.SaleOrderStatus.ORDERED) {
          step = 2;
        } else if (orderItem?.status === AgencyConstants.SaleOrderStatus.PAID) {
          if (!Utils.isValid(contractItem)) {
            step = 3;
          } else {
            if (contractItem?.status === AgencyConstants.ContractStatus.CREATED) step = 3;
            else if (contractItem?.status === AgencyConstants.ContractStatus.ADMIN_SIGNED) step = 4;
            else if (contractItem?.status === AgencyConstants.ContractStatus.AGENCY_SIGNED)
              step = 5;
            else step = 6;
          }
        } else if (orderItem?.status === AgencyConstants.SaleOrderStatus.COMPLETED) {
          step = 6;
        }
      } else if (orderType === AgencyConstants.SaleOrderType.LANDLORD) {
        // don hang gioi thieu mat bang
        if (orderItem?.status === AgencyConstants.SaleOrderStatus.ORDERED) {
          step = 2;
        } else if (orderItem?.status === AgencyConstants.SaleOrderStatus.PAID) {
          if (!Utils.isValid(contractItem)) {
            step = 2;
          } else {
            if (contractItem?.status === AgencyConstants.ContractStatus.CREATED) step = 2;
            else if (contractItem?.status === AgencyConstants.ContractStatus.ADMIN_SIGNED) step = 3;
            else if (contractItem?.status === AgencyConstants.ContractStatus.COMPLETED) step = 4;
          }

          if (Utils.isValid(technicalAcceptance)) {
            if (technicalAcceptance?.status === AgencyConstants.AcceptanceStatus.COMPLETED) step = 5;
          }
        } else if (
          [
            AgencyConstants.SaleOrderStatus.SHIPPING,
            AgencyConstants.SaleOrderStatus.INSTALLING,
          ].includes(orderItem?.status)
        ) step = 4;
        else if (orderItem?.status === AgencyConstants.SaleOrderStatus.INSTALLED) {
          step = 5;
        }
        else if (orderItem?.status === AgencyConstants.SaleOrderStatus.SIGNED) {
          step = 6;
        }
        else if (orderItem?.status === AgencyConstants.SaleOrderStatus.COMPLETED) {
          step = 6;
        }
      } else if (orderType === AgencyConstants.SaleOrderType.CHARGEPOINT) {
        // don hang ban tru sac
        if (orderItem?.status === AgencyConstants.SaleOrderStatus.ORDERED) {
          step = 2;
        } else if (orderItem?.status === AgencyConstants.SaleOrderStatus.PAID) {
          step = 3;
        } else if (orderItem?.status === AgencyConstants.SaleOrderStatus.COMPLETED) {
          step = 4;
        }
      }
    }
    setCurrentStep(step);
  }, [orderType, orderItem, contractItem]);
  const wizardStepItems = useMemo(() => {
    let steps = [];
    // don hang ban goi dau tu HTKD
    if (orderType === AgencyConstants.SaleOrderType.GROUP) {
      steps = [
        {
          active: currentStep === 1,
          done: currentStep > 1,
          step: 1,
          title: currentStep > 1 ? 'Đã tạo đơn hàng' : 'Tạo đơn hàng',
          subTitle: isAdmin ? 'NĐH tạo đơn hàng' : 'Đại lý tạo đơn hàng',
        },
        {
          active: currentStep === 2,
          done: currentStep > 2,
          step: 2,
          title:
            currentStep > 2
              ? 'Đã phê duyệt thanh toán'
              : currentStep === 2
                ? 'Chờ phê duyệt thanh toán'
                : 'Phê duyệt thanh toán',
          subTitle: 'NĐH nhấn nút “Duyệt thanh toán”',
        },
        {
          active: currentStep === 3,
          done: currentStep > 3,
          step: 3,
          title:
            currentStep > 3
              ? 'Đã tạo và ký hợp đồng'
              : currentStep === 3
                ? 'Chờ tạo và ký hợp đồng'
                : 'Tạo và ký hợp đồng',
          subTitle: 'NĐH tạo và ký hợp đồng',
        },
        {
          active: currentStep === 4,
          done: currentStep > 4,
          step: 4,
          title:
            currentStep > 4
              ? 'Nhà đầu tư đã ký'
              : currentStep === 4
                ? 'Chờ nhà đầu tư ký'
                : 'Nhà đầu tư ký',
          subTitle: 'NĐT ký hợp đồng và giấy ủy quyền',
        },
        {
          active: currentStep === 5,
          done: currentStep > 5,
          step: 5,
          title: currentStep > 5 ? 'NNUQ đã ký' : currentStep === 5 ? 'Chờ NNUQ ký' : 'NNUQ ký',
          subTitle: 'NNUQ ký giấy ủy quyền',
        },
      ];
    } else if (orderType === AgencyConstants.SaleOrderType.INVESTOR) {
      // don hang ban nhuong quyen
      steps = [
        {
          active: currentStep === 1,
          done: currentStep > 1,
          step: 1,
          title: currentStep > 1 ? 'Đã tạo đơn hàng' : 'Tạo đơn hàng',
          subTitle: isAdmin ? 'NĐH tạo đơn hàng' : 'Đại lý tạo đơn hàng',
        },
        {
          active: currentStep === 2,
          done: currentStep > 2,
          step: 2,
          title:
            currentStep > 2
              ? 'Đã tạo và ký HĐ'
              : currentStep === 2
                ? 'Chờ tạo và ký HĐ'
                : 'Tạo và ký hợp đồng',
          subTitle: 'NĐH tạo và ký hợp đồng',
        },
        {
          active: currentStep === 3,
          done: currentStep > 3,
          step: 3,
          title:
            currentStep > 3
              ? 'NĐT Đã ký hợp đồng'
              : currentStep === 3
                ? 'Chờ ký hợp đồng'
                : 'NĐT ký hợp đồng',
          subTitle: 'Nhà đầu tư ký hợp đồng',
        },
        {
          active: currentStep === 4,
          done: currentStep > 4,
          step: 4,
          title:
            currentStep > 4
              ? 'Đã duyệt tạm ứng'
              : currentStep === 4
                ? 'Chờ duyệt tạm ứng'
                : 'Duyệt tạm ứng',
          subTitle: 'Nhấn nút “Duyệt tạm ứng”',
        },
        {
          active: currentStep === 5,
          done: currentStep > 5,
          step: 5,
          title:
            currentStep > 5
              ? 'Đã nghiệm thu'
              : currentStep === 5
                ? 'Chờ nghiệm thu'
                : 'Nghiệm thu',
          subTitle: 'Tạo và ký BBNT thanh toán',
        },
      ];
    } else if (orderType === AgencyConstants.SaleOrderType.LANDLORD) {
      steps = [
        {
          active: currentStep === 1,
          done: currentStep > 1,
          step: 1,
          title: currentStep > 1 ? 'Đã tạo đơn hàng' : 'Tạo đơn hàng',
          subTitle: isAdmin ? 'NĐH tạo đơn hàng' : 'Đại lý tạo đơn hàng',
        },
        {
          active: currentStep === 2,
          done: currentStep > 2,
          step: 2,
          title:
            currentStep > 2
              ? 'Đã duyệt đơn và ký HĐ'
              : currentStep === 2
                ? 'Chờ duyệt đơn và ký HĐ'
                : 'Duyệt đơn và ký HĐ',
          subTitle: 'NĐH duyệt đơn và ký hợp đồng thuê mặt bằng',
        },
        {
          active: currentStep === 3,
          done: currentStep > 3,
          step: 3,
          title:
            currentStep > 3
              ? 'Chủ MB đã ký HĐ'
              : currentStep === 3
                ? 'Chờ chủ MB ký HĐ'
                : 'Chủ MB ký hợp đồng',
          subTitle: 'Chủ mặt bằng ký hợp đồng cho thuê mặt bằng',
        },
        {
          active: currentStep === 4,
          done: currentStep > 4,
          step: 4,
          title:
            currentStep > 4
              ? 'Đã lắp đặt & nghiệm thu'
              : currentStep === 4
                ? 'Chờ lắp đặt & nghiệm thu'
                : 'Lắp đặt & nghiệm thu',
          subTitle: 'Kỹ thuật viên tiến hành lắp đặt và nghiệm thu trạm sạc',
        },
        {
          active: currentStep === 5,
          done: currentStep > 5,
          step: 5,
          title: currentStep > 5 ? 'Đã hoàn thành' : currentStep === 5 ? 'Chờ xác nhận' : 'Xác nhận hoàn thành',
          subTitle: 'NĐH xác nhận hoàn thành đơn hàng',
        },
      ];
    } else if (orderType === AgencyConstants.SaleOrderType.CHARGEPOINT) {
      steps = [
        {
          active: currentStep === 1,
          done: currentStep > 1,
          step: 1,
          title: currentStep > 1 ? 'Đã tạo đơn hàng' : 'Tạo đơn hàng',
          subTitle: isAdmin ? 'Nhà điều hành tạo đơn hàng' : 'Đối tác tạo đơn hàng',
        },
        {
          active: currentStep === 2,
          done: currentStep > 2,
          step: 2,
          title:
            currentStep > 2
              ? 'Đã duyệt thanh toán'
              : currentStep === 2
                ? 'Chờ duyệt thanh toán'
                : 'Duyệt thanh toán',
          subTitle: 'Nhấn nút “Duyệt thanh toán”',
        },
        {
          active: currentStep === 3,
          done: currentStep > 3,
          step: 3,
          title:
            currentStep > 3
              ? 'Đã tạo và tải lên hợp đồng scan'
              : currentStep === 3
                ? 'Chờ tạo và tải lên hợp đồng scan'
                : 'Tạo và tải lên hợp đồng scan',
          subTitle: 'NĐT tạo và tải lên hợp đồng',
        },
      ];
    }
    return steps;
  }, [orderType, orderItem, contractItem, currentStep, isAdmin, isAgency]);
  return (
    <div
      className="d-flex flex-row px-5 flex-wrap"
      style={{
        borderTop: `1px solid ${AppColors.gray[300]}`,
      }}
    >
      {wizardStepItems.map((stepItem, index) => {
        return (
          <WizardStep
            fill
            key={index}
            active={stepItem.active}
            done={stepItem.done}
            step={stepItem.step}
            title={stepItem.title}
            subTitle={stepItem.subTitle}
          />
        );
      })}
    </div>
  );
}

export default AgencySaleOrderWizardView;
